export { default as Img200 } from './processed/200/Alien3.jpg';
export { default as Img400 } from './processed/400/Alien3.jpg';
export { default as Imgthumb } from './processed/thumb/Alien3.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Alien3.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Alien3.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      4,
      221,
      6
    ],
    "_population": 82,
    "_hsl": [
      0.3348694316436252,
      0.9644444444444445,
      0.4411764705882353
    ]
  },
  "LightVibrant": {
    "_rgb": [
      168,
      246,
      136
    ],
    "_population": 175,
    "_hsl": [
      0.28484848484848485,
      0.8593750000000002,
      0.7490196078431373
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      5,
      119,
      24
    ],
    "_population": 195,
    "_hsl": [
      0.3611111111111111,
      0.9193548387096775,
      0.24313725490196078
    ]
  },
  "Muted": {
    "_rgb": [
      132,
      180,
      84
    ],
    "_population": 1,
    "_hsl": [
      0.25,
      0.39024390243902446,
      0.5176470588235295
    ]
  },
  "LightMuted": {
    "_rgb": [
      177,
      207,
      189
    ],
    "_population": 60,
    "_hsl": [
      0.4000000000000001,
      0.23809523809523814,
      0.7529411764705882
    ]
  },
  "DarkMuted": {
    "_rgb": [
      53,
      88,
      85
    ],
    "_population": 14,
    "_hsl": [
      0.4857142857142857,
      0.2482269503546099,
      0.27647058823529413
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Alien3.js